import {setLocale} from "yup";
import {nl} from "yup-locales";
setLocale(nl);

export default function validator(schema, modelValue, errors) {
    return function (field) {
        schema
            .validateAt(field, modelValue.value)
            .then(() => {
                errors.value[field] = "";
            })
            .catch(err => {
                errors.value[field] = err.message;
            });
    }
}